export default __webpack_public_path__ + "static/ipad-button-c8ae7a3d57dbe98e4c2fb00108127fdc.png";